import React, { useState, useEffect, useCallback } from "react"
import CarouselContents from "./CarouselContents"
import CarouselSlide from "./CarouselSlide"
import { useSelector, useDispatch } from "react-redux"
import { updateSortOptions } from '../store/actions/restaurantActions'

import tagIcon from '../icons/penguin.webp'
import chineseIcon from '../icons/chinese.webp'
import mexicanIcon from '../icons/taco.webp'
import pizzaIcon from '../icons/pizza.webp'
import pastaIcon from '../icons/pasta.webp'
import sushiIcon from '../icons/sushi.webp'
import americanIcon from '../icons/burger.webp'
import hotdogIcon from '../icons/hotdog.webp'
import thaiIcon from '../icons/thai.webp'
import irishIcon from '../icons/irish.webp'
import indianIcon from '../icons/indian.webp'
import frenchIcon from '../icons/french.webp'
import dartsIcon from '../icons/darts.webp'
import englishIcon from '../icons/english.webp'
import beerIcon from '../icons/beer.webp'
import ramenIcon from '../icons/ramen.webp'
import sandwichesIcon from '../icons/sandwiches.webp'
import seafoodIcon from '../icons/seafood.webp'
import hawaiianIcon from '../icons/hawaiian.webp'
import halalIcon from '../icons/halal.webp'
import dessertIcon from '../icons/dessert.webp'
import kebabIcon from '../icons/kebab.webp'
import vietnameseIcon from '../icons/vietnamese.webp'
import jamaicanIcon from '../icons/jamaican.webp'
import coffeeIcon from '../icons/coffee.webp'
import juiceBarIcon from '../icons/juiceBar.webp'
import mediterraneanIcon from '../icons/mediterranean.webp'
import koreanIcon from '../icons/korean.webp'
import cajunIcon from '../icons/cajun.webp'
import wineIcon from '../icons/wine.webp'
import bowlingIcon from '../icons/bowling.webp'
import cubanIcon from '../icons/cuban.webp'
import basqueIcon from '../icons/basque.webp'
import japaneseIcon from '../icons/japanese.webp'
import indonesianIcon from '../icons/indonesian.webp'

function setImage(tag){
  switch(tag){
        case 'indonesian':
          return(<div className='tagIcon' ><img alt="Tag Icon" style={{"paddingRight":"50%"}} height={55} src={indonesianIcon}/></div>)
          break;
        case 'japanese':
          return(<div className='tagIcon' ><img alt="Tag Icon" style={{"paddingRight":"50%"}} height={55} src={japaneseIcon}/></div>)
          break;
        case 'basque':
          return(<div className='tagIcon' ><img alt="Tag Icon" style={{"paddingRight":"50%"}} height={55} src={basqueIcon}/></div>)
          break;
        case 'cuban':
          return(<div className='tagIcon' ><img alt="Tag Icon" style={{"paddingRight":"50%"}} height={55} src={cubanIcon}/></div>)
          break;
        case 'bowling':
          return(<div className='tagIcon' ><img alt="Tag Icon" style={{"paddingRight":"50%"}} height={55} src={bowlingIcon}/></div>)
          break;
        case 'wine':
          return(<div className='tagIcon' ><img alt="Tag Icon" style={{"paddingRight":"50%"}} height={55} src={wineIcon}/></div>)
          break;
        case 'cajun':
          return(<div className='tagIcon' ><img alt="Tag Icon" style={{"paddingRight":"50%"}} height={55} src={cajunIcon}/></div>)
          break;
        case 'korean':
          return(<div className='tagIcon' ><img alt="Tag Icon" style={{"paddingRight":"50%"}} height={55} src={koreanIcon}/></div>)
          break;
        case 'mediterranean':
          return(<div className='tagIcon' ><img alt="Tag Icon" style={{"paddingRight":"50%"}} height={65} src={mediterraneanIcon}/></div>)
          break;
        case 'juice bar':
          return(<div className='tagIcon' ><img alt="Tag Icon" style={{"paddingRight":"50%"}} height={65} src={juiceBarIcon}/></div>)
          break;  
        case 'coffee':
          return(<div className='tagIcon' ><img alt="Tag Icon" style={{"paddingRight":"50%"}} height={65} src={coffeeIcon}/></div>)
          break;
        case 'jamaican':
          return(<div className='tagIcon' ><img alt="Tag Icon" style={{"paddingRight":"50%"}} height={55} src={jamaicanIcon}/></div>)
          break;
        case 'vietnamese':
          return(<div className='tagIcon' ><img alt="Tag Icon" style={{"paddingRight":"50%"}} height={55} src={vietnameseIcon}/></div>)
          break;
        case 'kebab':
          return(<div className='tagIcon' ><img alt="Tag Icon" style={{"paddingRight":"50%"}} height={70} src={kebabIcon}/></div>)
          break;
        case 'dessert':
          return(<div className='tagIcon' ><img alt="Tag Icon" style={{"paddingRight":"50%"}} height={55} src={dessertIcon}/></div>)
          break;
        case 'halal':
          return(<div className='tagIcon' ><img alt="Tag Icon" style={{"paddingRight":"50%"}} height={55} src={halalIcon}/></div>)
          break;
        case 'hawaiian':
          return(<div className='tagIcon' ><img alt="Tag Icon" style={{"paddingRight":"50%"}} height={55} src={hawaiianIcon}/></div>)
          break;
        case 'seafood':
          return(<div className='tagIcon' ><img alt="Tag Icon" style={{"paddingRight":"50%"}} height={55} src={seafoodIcon}/></div>)
          break;
        case 'sandwiches':
          return(<div className='tagIcon' ><img alt="Tag Icon" style={{"paddingRight":"50%"}} height={50} src={sandwichesIcon}/></div>)
          break;
        case 'ramen':
          return(<div className='tagIcon' ><img alt="Tag Icon" style={{"paddingRight":"50%"}} height={55} src={ramenIcon}/></div>)
          break;
        case 'brewery':
        return(<div className='tagIcon' ><img alt="Tag Icon" style={{"paddingRight":"50%"}} height={55} src={beerIcon}/></div>)
          break;
        case 'english':
          return(<div className='tagIcon' ><img alt="Tag Icon" style={{"paddingRight":"50%"}} height={70} src={englishIcon}/></div>)
          break;
        case 'darts':
          return(<div className='tagIcon' ><img alt="Tag Icon" style={{"paddingRight":"20%"}} height={55} src={dartsIcon}/></div>)
          break;
        case 'french':
          return(<div className='tagIcon' ><img alt="Tag Icon" style={{"paddingRight":"0%"}} height={55} src={frenchIcon}/></div>)
          break;
        case 'indian':
          return(<div className='tagIcon' ><img alt="Tag Icon" style={{"paddingRight":"20%"}} height={55} src={indianIcon}/></div>)
          break;
        case 'irish':
          return(<div className='tagIcon' ><img alt="Tag Icon" style={{"paddingRight":"50%"}} height={55} src={irishIcon}/></div>)
          break;
        case 'chinese':
          return(<div className='tagIcon' ><img alt="Tag Icon" style={{"paddingRight":"50%"}} height={65} src={chineseIcon}/></div>)
          break;
        case 'pizza':
          return(<div className='tagIcon' ><img alt="Tag Icon" style={{"paddingRight":"50%"}} height={55} src={pizzaIcon}/></div>)
          break;
        case 'mexican':
          return(<div className='tagIcon' ><img alt="Tag Icon" style={{"paddingRight":"50%"}} height={55} src={mexicanIcon}/></div>)
          break;
        case 'american':
          return(<div className='tagIcon' ><img alt="Tag Icon" style={{"paddingRight":"50%"}} height={55} src={americanIcon}/></div>)
          break;
        case 'hotdog':
          return(<div className='tagIcon' ><img alt="Tag Icon" style={{"paddingRight":"50%"}} height={55} src={hotdogIcon}/></div>)
          break;
        case 'pasta':
          return(<div className='tagIcon' ><img alt="Tag Icon" style={{"paddingRight":"50%"}} height={55} src={pastaIcon}/></div>)
          break;
        case 'sushi':
          return(<div className='tagIcon' ><img alt="Tag Icon" style={{"paddingRight":"50%"}} height={50} src={sushiIcon}/></div>)
          break;
        case 'thai':
          return(<div className='tagIcon' ><img alt="Tag Icon" style={{"paddingRight":"50%"}} height={65} src={thaiIcon}/></div>)
          break;    
        default:
          return(<div className='tagIcon' ><img alt="Tag Icon" style={{"paddingRight":"50%"}} height={55} src={tagIcon}/></div>)
          break;
        }
}

function Carousel({ contents }) {
  // The value of the item that is supposed to be the center
  const selectSortOptions = useSelector((state)=>state.restaurant.sortOptions);
  const [centerVal, setCenterVal] = useState(selectSortOptions.carouselPosition);
  const dispatch = useDispatch();
  useEffect(()=>{if(selectSortOptions.carouselPosition !== centerVal){
    selectSortOptions.carouselPosition = centerVal;
    dispatch(updateSortOptions(selectSortOptions));}
  },[centerVal])
  // const callbackSortOptions = useCallback((sortOptions) => dispatch(updateSortOptions(sortOptions)), []);
  // useEffect( () => () => {console.log("unmount");
  //                         selectSortOptions.carouselPosition = centerVal;
  //                         callbackSortOptions(selectSortOptions);       
  //                         }, [] );
  
  // Length of contents must be >= 5 as window size is 5
  return (
    <>
      <CarouselContents centerVal={centerVal} setCenterVal={setCenterVal}>
        {contents.map((q, index) => {
          //console.log(q.label, index);
          return (
            <CarouselSlide key={index + 1} val={index + 1} >
              { <div onClick={function(){selectSortOptions.sortTags = [{"value":q.label,"label":q.label}];
                selectSortOptions.sortName = [];
                selectSortOptions.sortCombined = [{"value":q.label,"label":q.label}];
                selectSortOptions.carouselPosition = centerVal;
                dispatch(updateSortOptions(selectSortOptions));
              }}>
                {setImage(q.label)}
                </div>
              }
            </CarouselSlide>
          );
        })}
      </CarouselContents>
    </>
  );
}

export default Carousel;